<template>
    <div id="banner">
        <ul>
            <li><a href="/index.html"><img src="../assets/images/clubIcon.png"/><span>首页</span></a></li>            
            <li><a href="/store/index.html"><img src="../assets/images/storeIcon.png"/><span>旺币商城</span></a></li>            
            <li><a href="/game/index.html"><img src="../assets/images/gameIcon.png"/><span>游戏乐园</span></a></li>            
            <li><a href="/emoji/index.html"><img src="../assets/images/emojiIcon.png"/><span>表情符号</span></a></li>            
        </ul>
    </div>
</template>
<script>
    export default{
        data(){
            return{
               
            }
        }
    }
</script>
<style scoped>
    #banner{
        width:96%;
        padding:2% 0;
        margin:0 auto;
    }
    #banner ul{
        width: 100%;
        overflow: hidden;
        padding:6% 0 4%;
    }
    #banner>ul>li{
        float:left;
        width: 25%;
    }
    #banner>ul>li a{
        width: 100%;
        display: block;
        text-align: center;
        padding:0 2%;
    }
    #banner>ul>li a img{
        width: 56%;
    }
    #banner>ul>li a span{
        display: block;
        font-size:1.3rem;
        color: #333;
        padding:.5rem 0;
    }
</style>


// WEBPACK FOOTER //
// Banner.vue?12ded800